import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import injectStyles from 'react-jss'
import { Box, Grid } from '@material-ui/core'
import { styles } from './styles'
import PromofySvg from '../../../Assets/Images/icons/OppiziSvg'

const AuthWrapper = ({ classes, children }) => {
  const year = new Date().getFullYear()

  useEffect(() => {
    document.body.style.minWidth = 'initial'
  }, [])

  return (
    <Grid container direction="column" className={classes.background}>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="stylesheet" href="https://use.typekit.net/ixx5mpn.css" />
      </Helmet>
      <Box className={classes.wrap}>
        <a
          href="https://promofy.marketing/"
          className={classes.svgWrap}
          cypress_id={'oppiziLogo'}
        >
          <PromofySvg />
        </a>
        {children}
      </Box>
      <div className={classes.bottomBlock}>
        © {year} Promofy Technologies Inc. All rights reserved. "Promofy" are
        trademarks of Promofy Technologies Inc.
      </div>
    </Grid>
  )
}

export default injectStyles(styles)(AuthWrapper)
